import React from 'react';
import Head from 'next/head';
import BaseLayout from '@/components/common/BaseLayout';
import PrivacyPolicy from '../components/PrivacyPolicy';
import TAGS from '../../public/headJson.json';
import RouteName from '../utils/route.util';

const PrivacyPolicyPage = () => {
  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.privacyPolicy.title}</title>
        <meta name="title" content={TAGS.privacyPolicy.title} />
        <meta name="description" content={TAGS.privacyPolicy.desc} />
        <link rel="canonical" href={`${RouteName.privacyPolicy}/`} />

        {/* Open Graph / Facebook */}
        <meta property="og:url" content={RouteName.privacyPolicy} />
        <meta property="og:title" content={TAGS.privacyPolicy.title} />
        <meta property="og:description" content={TAGS.privacyPolicy.desc} />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.privacyPolicy} />
        <meta property="twitter:title" content={TAGS.privacyPolicy.title} />
        <meta property="twitter:description" content={TAGS.privacyPolicy.desc} />
      </Head>
      <BaseLayout category={undefined}>
        <PrivacyPolicy />
      </BaseLayout>
    </>
  );
};

export default PrivacyPolicyPage;
